var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mb-5"},[_vm._v("Latest Staff Identities")]),_vm._l((_vm.profiles),function(profile){return _c('ProfileCard',{key:profile.id,attrs:{"profile":profile,"admin":_vm.isAdmin}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }